import React from 'react';
var Main = function (_a) {
    var children = _a.children;
    return (React.createElement("main", { className: 'main' }, children));
};
export default Main;
